import React from 'react'
import { Form } from 'formik'
import { FormField } from '../../components/Form/FormField'

const EditComponent = (props) => {
  const {
    values,
    submitForm,
    errors,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
    resetForm,
    setFieldValue,
    setValues,
    isSubmitting,
    formStyle,
    userGroups: groups,
  } = props

  const isAdmin = groups.map((x) => x.toLowerCase()).includes('admin')

  return (
    <Form style={formStyle} autoComplete='off'>
      <div>
        <FormField
          disabled={!groups.includes('admin')}
          fieldName='vendor'
          value={values.vendor}
          handleBlur={handleBlur}
          handleChange={handleChange}
        />

        <FormField
          // disabled
          fieldName='date'
          value={values.date}
          handleBlur={handleBlur}
          handleChange={handleChange}
        />

        <FormField
          // disabled
          fieldName='invoiceNumber'
          value={values.invoiceNumber}
          handleBlur={handleBlur}
          handleChange={handleChange}
        />
      </div>
      <div>
        <FormField
          disabled={!groups.includes('admin')}
          fieldName='invoiceType'
          value={values.invoiceType}
          handleBlur={handleBlur}
          handleChange={handleChange}
        />

        <FormField
          disabled
          fieldName='costCurrency'
          value={values.costCurrency}
        />
        <FormField
          disabled={!groups.includes('admin')}
          fieldName='amountExclVat'
          value={values.amountExclVat}
          handleBlur={handleBlur}
          handleChange={handleChange}
        />
      </div>

      <div>
        <FormField
          multiline
          fieldName='memo'
          value={values.memo}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
        />
      </div>
    </Form>
  )
}

export default EditComponent
